import React, { useEffect } from 'react';
import { Button } from 'antd';
import cn from 'classnames';
import styles from './index.module.less';
import { IUseEarlyAccess } from '@pro/activity/testerClub/useEarlyAccess';
import { ITabActivityKey, ITabButtonType } from '@pro/activity/testerClub/interface';
import { useTrans } from 'base/utils/i18n';
import { useRouter } from 'next/router';
import { scrollToAnchor } from 'base/utils/scrollTo';
import { Swiper, SwiperSlide } from 'swiper/react';

type IProps = {
    earlyAccess: IUseEarlyAccess
}

type ITabConfigs = {
    key: ITabActivityKey,
    label: string;
    type: 'tab' | 'button',
    labelLanguageCode: string;
}
const tabConfigs: ITabConfigs[] = [
    {
        key: 'onGoing',
        label: 'Ongoing',
        type: 'tab',
        labelLanguageCode: 'web_shop_activity_early_access_ongoing'
    },
    {
        key: 'completed',
        label: 'Completed',
        type: 'tab',
        labelLanguageCode: 'web_shop_activity_early_access_completed'
    },
    {
        key: 'reviews',
        label: 'Reviews',
        type: 'button',
        labelLanguageCode: 'web_common_reviews'
    },
]

const isPhone = process.env.NEXT_PUBLIC_TERMINAL === 'm';

const Tabs: React.FC<IProps> = (props) => {
    const { t } = useTrans();

    const { earlyAccess } = props
    const { tabActivityKey, onChangeTab } = earlyAccess

    const { query } = useRouter();
    const { activityId = '' } = query


    useEffect(() => {
        if (activityId) {
            // 切换到 completed tab (展示结果弹窗)
            onChangeTab('completed')
        }
    }, [activityId])


    const onClickTab = (key: ITabButtonType) => {
        if (key === 'reviews') {
            // 锚点评论模块
            scrollToAnchor({
                selector: '#js-tester-reviews',
            })
        }
    }


    return (
        <div
            className={cn(
                styles['btns-wrap'],
                !isPhone && 'flex-center flex'
            )}
        >
            <Swiper
                pagination={false}
                slidesPerView={'auto'}
                className={'g-nav'}
                spaceBetween={10}
                // centeredSlides={!isPhone}
            >

                {tabConfigs.map((item) => {
                    return (
                        <SwiperSlide
                            key={item.key}
                            className={cn('g-nav-item')}
                        >
                            <Button
                                key={item.key}
                                type={'primary'}
                                className={cn(styles.btn, tabActivityKey === item.key && styles.on)}
                                onClick={() => {
                                    item.type === 'tab' ? onChangeTab(item.key) : (
                                        item.type === 'button' ? onClickTab(item.key as ITabButtonType) : void 0
                                    )
                                }}
                            >{t(item.labelLanguageCode)}</Button>
                        </SwiperSlide>

                    )
                })}
            </Swiper>
{/*

            {tabConfigs.map((item) => {
                return (
                    <Button
                        key={item.key}
                        type={'primary'}
                        className={cn(styles.btn, tabActivityKey === item.key && styles.on)}
                        onClick={() => {
                            item.type === 'tab' ? onChangeTab(item.key) : (
                                item.type === 'button' ? onClickTab(item.key as ITabButtonType) : void 0
                            )
                        }}
                    >{t(item.labelLanguageCode)}</Button>
                )
            })}*/}
        </div>
    );
};

export default Tabs